<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">サブステータス情報 修正</h1>
    <span class="close" (click)="close()"></span>
  </div>
  <div class="dialog__body">
    <div class="dialog__contents">
      <ag-dynamic-form
        [metadata]="jobScreeningInfo1Meta"
        [model]="jobScreeningInfoDataModel"
        *ngIf="jobScreeningInfo1Meta && jobScreeningInfoData.type"
      ></ag-dynamic-form>
      <ag-dynamic-form
        [metadata]="jobScreeningInfo2Meta"
        [model]="jobScreeningInfoDataModel"
        *ngIf="jobScreeningInfo2Meta && jobScreeningInfoData.type"
      ></ag-dynamic-form>
    </div>
  </div>
  <div class="dialog__footer">
    <button class="dialog__button dialog__button--accent" (click)="close()">
      キャンセル
    </button>
    <button
      [disabled]="!isValidJobScreeningInfoData()"
      class="dialog__button dialog__button--accent"
      (click)="deleteJobScreeningInfo()"
    >
      削除
    </button>
    <button
      [disabled]="!isValidJobScreeningInfoData()"
      class="dialog__button dialog__button--primary"
      (click)="reflect()"
    >
      更新
    </button>
  </div>
</div>
